// extracted by mini-css-extract-plugin
export default {"subTabContainer":"E_4t4tP7T_t8BJC5C3zq","addNoteButton":"ReR2cyOk6VEI4FnvORjM","notesList":"Mtx6LwIB8f6dJ7xXTTF3"};